import React from 'react';
import DealerAPI from '../../api/dealer.jsx';
import BugReportModal from '../components/layout/BugReportModal.jsx';
import Cookies from 'js-cookie';
import router from '../../lib/router.js';
import events from '../../lib/events.js';
import sessionService from '../../services/sessionService.jsx';
import NavBar from '../components/layout/navBar.jsx';
import ScanProgress from '../components/layout/scanProgressBar.jsx';
import NotificationBar from '../components/layout/notificationBar.jsx';
import IntroVideo from '../components/introVideo.jsx';
import SideBar from '../components/layout/sideBar.jsx';
import ErrorBar from '../components/layout/errorBar.jsx';
import TOSBar from '../components/layout/tosBar.jsx';
import TestConnectHistory from '../components/layout/tcHistory';
import TestConnectStatusBar from '../page/analysis/testConnectStatusBar';
import hopscotch from 'hopscotch';
import template from 'lodash/template';
import TestConnectStatusService from '../../services/tcStatusService';
import IntlWrapper from '../components/layout/intlWrapper';
import {FormattedMessage, injectIntl, intlShape} from 'react-intl';
import {testConnectSidebarEnabled} from 'features';
import DashboardApi from 'api/dashboard';

class Layout extends React.Component {
  static propTypes = {
    intl: intlShape.isRequired,
  };

  state = {
    title: 'Loading...',
    navigation: '#',
    user: null,
    bgGradient: false,
    siteerror: false,
    forceTOSBarFixed: false,
    showTcOverlay: false,
  };

  componentWillMount() {
    console.log('checking login redirect page.');
    let redirectLink = Cookies.get('failed-login-attempted-page');

    console.log('Redirecting to pre-login page: ' + redirectLink);
    if (redirectLink) {
      Cookies.remove('failed-login-attempted-page');
      window.location.hash = redirectLink;
    } else {
      console.log('No page to redirect to.');
    }
  }

  componentDidMount() {
    window.appInsights.trackPageView();

    // Subscribe to events
    this._eventHashchange = events.subscribe('hashchange', this.urlDidChange);
    this.urlDidChange(window.location.hash);
    this._userChange = events.subscribe('userset', this.userDidChange);
    this.setState({user: sessionService.getUser()}, () => {
      if (this.state.user) {
        DashboardApi.initialize();
      }
    });
    this._eventSiteErrorOn = events.subscribe('siteerror.error', this.siteErrorOn);
    this._eventSiteErrorOff = events.subscribe('siteerror.success', this.siteErrorOff);
    document.addEventListener('click', this.handleClickOutside.bind(this), true);

    this.updateHopscotchRenderer();

    let {remove} = events.subscribe('locale.changed', this.updateHopscotchRenderer);

    this.removeLocaleListener = remove;
  }

  componentWillUnmount() {
    this._eventHashchange.remove();
    this._userChange.remove();
    this._eventSiteErrorOn.remove();
    this._eventSiteErrorOff.remove();
    document.removeEventListener('click', this.handleClickOutside.bind(this), true);

    if (this.removeLocaleListener) {
      this.removeLocaleListener();
    }
  }

  updateHopscotchRenderer = () => {
    hopscotch.setRenderer(template(`
<%
  function optEscape(str, unsafe){
    if(unsafe){
      return _.escape(str);
    }
    return str;
  }
  
  function getSteps(current, total) {
    return fm({id: 'general.step.range'}, {n: current, total: total});
  }
%>
<div class="hopscotch-bubble-container" style="width: <%= step.width %>px; padding: <%= step.padding %>px;">
  <div class="hopscotch-bubble-content">
    <% if(step.title !== ''){ %><h3 class="hopscotch-title"><%= optEscape(step.title, tour.unsafe) %></h3><% } %>
    <% if(step.content  !== ''){ %><div class="hopscotch-content"><%= optEscape(step.content, tour.unsafe) %></div><% } %>
  </div>
  <div class="hopscotch-actions">
    <% if(tour.customData.showSteps){ %><div class="steps-indicator"><%= getSteps(i18n.stepNum, tour.numSteps) %></div><% } %>
    <% if(buttons.showCTA){ %><button class="hopscotch-nav-button next hopscotch-cta"><%= buttons.ctaLabel %></button><% } %>
    <% if(buttons.showNext){ %><button class="hopscotch-nav-button next hopscotch-next"><%= i18n.nextBtn %></button><% } %>
    <% if(buttons.showPrev){ %><button class="hopscotch-nav-button prev hopscotch-prev"><%= i18n.prevBtn %></button><% } %>
  </div>
  <% if(buttons.showClose){ %><button class="hopscotch-bubble-close hopscotch-close"><%= i18n.closeTooltip %></button><% } %>
</div>
<div class="hopscotch-bubble-arrow-container hopscotch-arrow">
  <div class="hopscotch-bubble-arrow-border"></div>
  <div class="hopscotch-bubble-arrow"></div>
</div>
`, {
  imports: {
    fm: this.props.intl.formatMessage,
  },
}));
  };

  _eventHashchange = null;
  _eventSiteErrorOff = null;
  _eventSiteErrorOn = null;
  _userChange = null;

  siteErrorOff = () => {
    this.setState({siteerror: false});
  };

  siteErrorOn = msg => {
    this.setState({siteerror: msg});
  };

  urlDidChange = loc => {
    console.log(loc);
    if (loc.charAt(0) === '#') {
      loc = loc.substr(1);
    }
    if (['signIn', 'forgotPassword', 'resetPassword'].indexOf(loc) !== -1 || loc.indexOf('resetPassword') !== -1) {
      this.setState({bgGradient: true}); // Special gradient background just for sign-in pages
    } else {
      this.setState({bgGradient: false});
    }

    //Force TOSBar to be fixed to the bottom to improve long notifications readability
    this.setState({forceTOSBarFixed: loc.indexOf('notifications') !== -1});

    let body = document.getElementById('body-container');
    let route = router.rr.recognize(loc);

    if (route) {
      console.info('[UI.layout.container] New route found', loc, route);
      route[0].handler(body, route[0].params);
    } else {
      console.error('[UI.layout.container] No route found', loc);
      events.publish('error.user', {message: 'Route does not exist'});
    }
  };

  userDidChange = data => {
    console.log('user did change', data);
    if (data && data.dealerId) {
      DealerAPI.getDealer(data.dealerId).then(dealer => {
        this.setState({user: data, dealer: dealer});
      });
    } else {
      this.setState({user: data});
    }
  };


  toggleTcOverlay = () => {
    this.setState({
      showTcOverlay: !this.state.showTcOverlay,
    });
  };

  openTcOverlay = () => {
    this.setState({
      showTcOverlay: true,
    });
  };

  closeTcOverlay = () => {
    this.setState({
      showTcOverlay: false,
    });
  };

  handleClickOutside(event) {
    const domNode = this.tcOverlay;
    let iconClicked = event.target.src && event.target.src.toLowerCase().indexOf('tcbeaker') !== -1;

    if (!iconClicked && (!domNode || !domNode.contains(event.target))) {
      this.closeTcOverlay();
    }
  }

  render() {
    let isLoggedIn = !!this.state.user;

    let navbar = null;
    let sidebar = null;
    let video = null;
    let tosBar = null;

    let tcStyle = {
      transform: this.state.showTcOverlay ? 'scale(1)' : 'scale(0)',
    };

    let tcOverlay = <IntlWrapper>
      <div ref={i => { this.tcOverlay = i; }} className='tcOverlay' style={tcStyle}>
        <h2><FormattedMessage id='tc-overlay.status.title'/></h2>
        <TestConnectStatusBar showBorder={false}/>
        <hr />
        <h2><FormattedMessage id='tc-overlay.history.title'/></h2>
        <TestConnectHistory toggleTcOverlay={this.toggleTcOverlay}/>
        <div className='triangle'>◀</div>
        <div className='triangle-clip'/>
      </div>
    </IntlWrapper>;


    if (isLoggedIn) {
      navbar = <NavBar user={this.state.user} />;
      sidebar = <SideBar toggleTcOverlay={this.toggleTcOverlay} user={this.state.user} dealer={this.state.dealer} />;
      tosBar = <TOSBar fixed={this.state.forceTOSBarFixed}/>;
    }

    if (isLoggedIn && !this.state.user.video) {
      video = <IntroVideo user={this.state.user} />;
    }

    let errorbar = '';

    if (this.state.siteerror) {
      errorbar = <ErrorBar message={this.state.siteerror} />;
    }

    return <div id='page-main'
                className={this.state.bgGradient ? 'bgGradient vert-center' : ''}
                style={window.location.hash.indexOf('#notifications') !== -1 ? {overflow: 'hidden'} : {}}>
      {errorbar}
      {navbar}
      {sidebar}
      {testConnectSidebarEnabled ? tcOverlay : null}
      <BugReportModal/>
      <div id='navmargin'
           className={'nav-page-margin ' + (isLoggedIn ? 'nav-page-margin-top' : 'nav-page-margin-top-none')}>
        <ScanProgress/>
        <NotificationBar debugMode={true}/>
        {video}
        <div id='body-container'/>
        {tosBar}
      </div>
    </div>;
  }
}

export default injectIntl(Layout);
